import { configureStore } from '@reduxjs/toolkit';
import {
    TypedUseSelectorHook,
    useDispatch as useDispatchGeneric,
    useSelector as useSelectorGeneric,
} from 'react-redux';

import appointment from './appointment';
import bookingFlow from './bookingFlow';
import customer from './customer';

export const store = configureStore({
    reducer: {
        appointment,
        bookingFlow,
        customer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useSelector: TypedUseSelectorHook<RootState> = useSelectorGeneric;
export const useDispatch = useDispatchGeneric<AppDispatch>;

export * from './types';
